import { marked } from "marked";
import DOMPurify from "dompurify";

export const chatbotUtil = {
  /**
   * @description 사용자 입력 메시지를 줄바꿈 처리 하기 위해 <br> 태그로 변환 + 큰따옴표를 이스케이프 처리하여 JSON 파싱 오류 방지
   * @param message 사용자 입력 메시지
   * @returns
   */
  convertReqMessage: (message: string) => {
    if (!message) return "";

    return message.replace(/(\r\n|\n|\r)/gm, "<br />").replaceAll('"', '\\"');
  },
  /**
   * @description 사용자 입력 메시지를 마크다운 형식으로 변환 (+ sanitize)
   * @param message 사용자 입력 메시지
   * @returns 마크다운 형식으로 변환된 메시지
   */
  getSanitizedMessage: async (message: string) => {
    if (!message) return "";

    const markedMessage = await marked(message, { breaks: true });

    return DOMPurify.sanitize(markedMessage);
  },
};
